<div class="sovendus-container" (click)="goToSovendus()">
  <div class="sovendus-headline">
    <h1 class="sovendus-headline--h1">
      {{ 'sovendus.headline' | transloco }}
    </h1>
  </div>
  <div class="sovendus-image">
    <img src="/assets/img/sovendus/giftbox.png" class="sovendus-image--surprise" [alt]="'sovendus.headline' | transloco" />
  </div>
  <div class="sovendus-copy">
    <p class="sovendus-copy--txt" [innerHTML]="'sovendus.txt' | transloco"></p>
    <p class="sovendus-copy-mobile--txt" [innerHTML]="'sovendus.txt-mobile' | transloco"></p>
  </div>
  <div class="sovendus-button-cnt">
    <a class="sovendus-button arrow-right" [title]="'sovendus.btn' | transloco">
      {{ 'sovendus.btn' | transloco }}
    </a>
  </div>
</div>
